export const findByKey = (data, key, value, rkey) => {
  const findRes = data.find((e) => {
    return e[key] == value;
  });
  return findRes ? findRes[rkey] : '';
};

export const phonesign = (phone) => {
  return phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2');
};

export const isIE9 = () => {
  if (
    navigator.appName == 'Microsoft Internet Explorer' &&
    parseInt(navigator.appVersion.split(';')[1].replace(/[ ]/g, '').replace('MSIE', '')) <= 9
  ) {
    return true;
  }
  return false;
};

export const isIE = () => {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) return true;
  else return false;
};
export const previewlink = (filepath) => {
  if (!filepath) {
    return '';
  }
  const filepaths = filepath.split('.');

  switch (filepaths[filepaths.length - 1]) {
    case 'png':
    case 'jpeg':
    case 'pdf':
    case 'jpg':
      return filepath;
    case 'xlsx':
    case 'xls':
    case 'doc':
    case 'docx':
      return 'https://view.officeapps.live.com/op/view.aspx?src=' + filepath;
  }
  return filepath;
};
